import Flickity from 'flickity';
require('flickity-imagesloaded');

window.addEventListener('DOMContentLoaded', () => {
  const sliders = [...document.querySelectorAll('.resources-carousel__carousel')];
  if (sliders.length) {
    sliders.map(slides => {

      const carousel = new Flickity(slides, {
        imagesLoaded: true,
        contain: true,
        cellAlign: 'left',
        adaptiveHeight: false,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        selectedAttraction: 0.028,
        friction: 0.25
      });

      slides.closest('.resources-carousel').querySelector('.resources-carousel__button--next').addEventListener('click', () => carousel.next());
      slides.closest('.resources-carousel').querySelector('.resources-carousel__button--prev').addEventListener('click', () => carousel.previous());

    });
  }
});
